import { render } from "./testReportUpload.vue?vue&type=template&id=4e1bf6a0&scoped=true"
import script from "./testReportUpload.vue?vue&type=script&lang=js"
export * from "./testReportUpload.vue?vue&type=script&lang=js"

import "./testReportUpload.vue?vue&type=style&index=0&id=4e1bf6a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1bf6a0"]])

export default __exports__